import React from 'react';

type StatusVariant =
  | 'available' |'booked' |'pending' |'confirmed' |'active' |'completed' |'cancelled' |'settled' |'stored' |'overdue';

interface StatusBadgeProps {
  status: StatusVariant;
  size?: 'sm' | 'md';
}

const variantMap: Record<StatusVariant, { bg: string; text: string; dot: string; label: string }> = {
  available: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Available' },
  booked: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500', label: 'Booked' },
  pending: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Pending' },
  confirmed: { bg: 'bg-indigo-50', text: 'text-indigo-700', dot: 'bg-indigo-500', label: 'Confirmed' },
  active: { bg: 'bg-teal-50', text: 'text-teal-700', dot: 'bg-teal-500', label: 'Active' },
  completed: { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400', label: 'Completed' },
  cancelled: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Cancelled' },
  settled: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Settled' },
  stored: { bg: 'bg-violet-50', text: 'text-violet-700', dot: 'bg-violet-500', label: 'Stored' },
  overdue: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Overdue' },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const v = variantMap[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-medium rounded-full ${v.bg} ${v.text} ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${v.dot} flex-shrink-0`} />
      {v.label}
    </span>
  );
}